<script>
	import { companyCapacityTypes } from "../config";
	import { handleNameChange } from "../helpers";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Checkbox from "./Checkbox.svelte";
	import Select from "./Select.svelte";

	export let name;
	export let capacity;
	export let acnAbn;
	export let authorisedToAct;
	export let disabled = null;
	export let required = null;
</script>

<FormRow>
	<FormColumn>
		<h3>Company Details</h3>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="4">
		<label for="name" class:isrequired={required}>Company Name</label>
		<input
			{required}
			{disabled}
			maxlength="1000"
			type="text"
			bind:value={name}
			id="name"
			class="form-control"
			on:change={() => (name = handleNameChange(name))} />
	</FormColumn>
	<FormColumn cols="4">
		<label for="acnAbn" class:isrequired={required}>ABN/ACN</label>
		<input {required} {disabled} maxlength="20" type="text" bind:value={acnAbn} id="acnAbn" class="form-control" />
	</FormColumn>
	<FormColumn cols="4">
		<label for="capacity">Capacity</label>
		<Select
			{disabled}
			bind:value={capacity}
			id="capacity"
			optionList={companyCapacityTypes}
			textProperty="name"
			valueProperty="name"></Select>
	</FormColumn>
</FormRow>
<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to register on behalf of the company"
			{required}
			id="authc"></Checkbox>
	</FormColumn>
</FormRow>
